import {apiPost} from './client';

export function createLinkToken({accountId, platform, yandexClientId}) {
    return apiPost('/celebs/account/link-token', {
        account_id: accountId,
        platform,
        yandex_client_id: yandexClientId || undefined,
    });
}
